import {
  ProteinLayerDTO,
  ProteinLayerProteinFormulationDTO,
} from 'business/models/Models';
import { EGridVaryAlong } from 'enums/ELayersView';

export const getProteinLayerProteinFromualtion = (
  proteinLayerDetail: ProteinLayerDTO,
  pf,
  layerId: number,
) => {
  let proteinFormulation = new ProteinLayerProteinFormulationDTO();
  if (proteinLayerDetail?.proteinLayerProteinFormulation?.length) {
    proteinFormulation = proteinLayerDetail.proteinLayerProteinFormulation[0];
  }
  proteinFormulation.proteinFormulationId = pf.pfId;
  proteinFormulation.proteinDropVolumeVaryAlong = EGridVaryAlong.NONE;
  proteinFormulation.startProteinDropVolume = pf.proteinVolume;
  proteinFormulation.stopProteinDropVolume = pf.proteinVolume;
  proteinFormulation.wellDropVolumeVaryAlong = EGridVaryAlong.NONE;
  proteinFormulation.startWellDropVolume = pf.dropVolume;
  proteinFormulation.stopWellDropVolume = pf.dropVolume;
  proteinFormulation.proteinLayerId = layerId;
  proteinFormulation.proteinFormulation = pf;
  return proteinFormulation;
};
